import React, { useState, useMemo } from 'react'
import { Button, Space, Modal } from 'antd'
import {
    DeleteOutlined,
    SelectOutlined,
    LoadingOutlined
} from '@ant-design/icons'
import styled from 'styled-components'
import IconSelectorList from './IconSelectorList'

const Container = styled.div`
    margin-bottom: 20px;
`

const IconSelector = ({ T, selectedIcon, onSelect }) => {
    let [icon, setIcon] = useState('')
    let [isOpenModal, setIsOpenModal] = useState(false)
    let [isOpenIconList, setIsOpenIconList] = useState(false)

    useMemo(() => {
        icon = selectedIcon
    }, [])

    function toggleModal(status) {
        setIsOpenModal(status)
        if (status) {
            setTimeout(() => {
                setIsOpenIconList(true)
            }, 100)
        }
    }

    function onCancel() {
        setIsOpenModal(false)
        setIsOpenIconList(false)
        setIcon(selectedIcon)
    }

    function onOk() {
        setIsOpenModal(false)
        setIsOpenIconList(false)
        onSelect(icon)
    }

    return (
        <Container>
            <Space>
                {selectedIcon && (
                    <div>
                        <span style={{ marginRight: 10 }}>
                            <i className={`icon-${selectedIcon}`}></i> (
                            {selectedIcon})
                        </span>
                    </div>
                )}
                <Button
                    type="primary"
                    icon={<SelectOutlined />}
                    onClick={() => toggleModal(true)}>
                    {T('CHOOSE')}
                </Button>
                {selectedIcon && (
                    <Button
                        type="primary"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => {
                            setIcon('')
                            onSelect('')
                        }}></Button>
                )}
            </Space>

            <Modal
                width={640}
                title={T('ICON')}
                centered
                destroyOnClose={true}
                visible={isOpenModal}
                okText={T('OK')}
                cancelText={T('CANCEL')}
                onOk={() => onOk()}
                onCancel={() => onCancel()}>
                {isOpenIconList ? (
                    <IconSelectorList
                        T={T}
                        selectedIcon={icon}
                        onSelect={setIcon.bind(this)}
                    />
                ) : (
                    <div style={{ textAlign: 'center' }}>
                        <LoadingOutlined />
                    </div>
                )}
            </Modal>
        </Container>
    )
}

export default IconSelector
